import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleDatePipe } from '@app/pipes/locale-date.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { SummaryItemComponent } from '@sb/ui/summary-item';

import { OpenShiftModel } from '../../../../reducers/orm/open-shift/open-shift.model';
import { SidebarHeaderComponent } from '../sidebar-header.component';
import { SidebarRequestItemDirective } from '../sidebar-request-item.directive';
import { TimePipe } from './../../../../pipes/time.pipe';

@Component({
  selector: 'open-shifts',
  templateUrl: './open-shifts.component.html',
  imports: [
    TimePipe,
    TranslatePipe,
    LocaleDatePipe,
    SummaryItemComponent,
    SidebarHeaderComponent,
    SidebarRequestItemDirective,
  ],
})
export class OpenShiftsComponent {
  private router = inject(Router);

  @Input()
  openShifts: OpenShiftModel[];

  @Output()
  acceptOpenShiftRequest = new EventEmitter<string>();
  @Output()
  rejectOpenShiftRequest = new EventEmitter<string>();

  showOpenShift(occurrenceId: string) {
    this.router.navigate(['', { outlets: { modal: ['schedule-open-shift', occurrenceId] } }]);
  }
}
